import React, { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './BriefingPage.css';

const briefingContent = {
  1:  { title: '01 — Executive Summary',          fileName: '01-executive-summary.html' },
  2:  { title: '02 — Investment Foundation',       fileName: '02-investment-foundation.html' },
  3:  { title: '03 — Legal / Tax / Financial',     fileName: '03-legal-tax-financial.html' },
  4:  { title: '04 — Operations & Brand',          fileName: '04-operations-brand.html' },
  5:  { title: '05 — Five-Family Governance',      fileName: '05-five-family-governance.html' },
  6:  { title: '06 — Retirement Livability',       fileName: '06-retirement-livability.html' },
  7:  { title: '07 — Risk Premortem',              fileName: '07-risk-premortem.html' },
  8:  { title: '08 — Recommendation & Next Steps', fileName: '08-recommendation-next-steps.html' },
  9:  { title: '09 — Commercial Simulator',        fileName: '09-commercial-simulator.html' },
  10: { title: '10 — References',                  fileName: '10-references.html' },
  11: { title: '11 — Property Portfolio',           fileName: '11-property-portfolio.html' },
};

export const BriefingPage = () => {
  const { pageNum } = useParams();
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const page = parseInt(pageNum, 10);
  const content = briefingContent[page];

  // Style the iframe content when it loads (hide duplicate nav, fix sidebar)
  const handleLoad = () => {
    setLoading(false);
    const iframe = iframeRef.current;
    if (!iframe) return;
    try {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (doc?.body) {
        // Hide the original nav-bar inside the iframe since the React app has its own
        const nav = doc.querySelector('.nav-bar');
        if (nav) nav.style.display = 'none';
        const bottomNav = doc.querySelector('.bottom-nav');
        if (bottomNav) bottomNav.style.display = 'none';
        const readingProgress = doc.querySelector('.reading-progress');
        if (readingProgress) readingProgress.style.display = 'none';
        // Remove top padding that accounted for the fixed nav
        const pageContent = doc.querySelector('.page-content');
        if (pageContent) pageContent.style.paddingTop = '0';
        // Remove padding-top from the page shell (was for the original fixed nav)
        const pageShell = doc.querySelector('.page-shell');
        if (pageShell) {
          pageShell.style.paddingTop = '0';
        }
        // Make sidebar sticky inside the scrollable iframe
        const sidebar = doc.querySelector('.sidebar');
        if (sidebar) {
          sidebar.style.position = 'sticky';
          sidebar.style.top = '0';
          sidebar.style.alignSelf = 'start';
          sidebar.style.maxHeight = '100vh';
          sidebar.style.overflowY = 'auto';
        }
      }
    } catch (e) {
      // Cross-origin safety
    }
  };

  const handleNext = () => { if (page < 11) navigate(`/briefing/${String(page + 1).padStart(2, '0')}`); };
  const handlePrev = () => { if (page > 1) navigate(`/briefing/${String(page - 1).padStart(2, '0')}`); };

  useEffect(() => {
    setLoading(true);
  }, [page]);

  if (!content) {
    return (
      <div className="briefing-error">
        <h2>Page not found</h2>
        <p>The briefing page you're looking for doesn't exist.</p>
        <button onClick={() => navigate('/briefing/01')}>Go to first page</button>
      </div>
    );
  }

  return (
    <div className="briefing-page">
      {loading && <div className="loading-spinner">Loading briefing...</div>}
      <iframe
        ref={iframeRef}
        src={`/${content.fileName}`}
        title={content.title}
        onLoad={handleLoad}
        className="briefing-iframe"
        style={{
          display: loading ? 'none' : 'block',
        }}
      />
      <div className="briefing-navigation">
        <button className="btn-nav btn-prev" onClick={handlePrev} disabled={page === 1}>
          ← Previous
        </button>
        <span className="page-indicator">Page {page} of 11</span>
        <button className="btn-nav btn-next" onClick={handleNext} disabled={page === 11}>
          Next →
        </button>
      </div>
    </div>
  );
};

export default BriefingPage;
